import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionService } from '@shared/services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private _session: SessionService) {}

  checkRequest(url: string) {
    const split = url.split('/');
    return (
      (!!split.find(i => i === 'api') && !split.find(i => i === 'access')) ||
      false
    );
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    if (this.checkRequest(request.url)) {
      this._session.resetSessionTime();
    }
    const decompressToken = this._session.getToken();
    if (decompressToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${decompressToken}`
        }
      });
    } else if (!decompressToken) {
      const obj = {
        isLogin: false
      };
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem('currentUser', JSON.stringify(obj));
    }

    return next.handle(request);
  }
}
